const sectionSocials = $('.section-social');
const changeTabButton = $('.js-change-social-files-tab');
const socialFilesWrapper = $('.js-loaded-social-content');

const loadTabContent = (element) => {
    const parentElement = element.parents('.section-social');
    const loader = parentElement[0].querySelector('.loader');
    const isSocialTurnedOff = sectionSocials.data("is-social");
    const data = {
        'action' : 'load_social_files',
        'blog_id' : element.data('blog-id'),
        'is_social_turned_off': isSocialTurnedOff
    }

    if(!element.hasClass('active')) {

        $.ajax({
            type: 'post',
            url: ajax.url,
            data: data,
            beforeSend: function () {
                changeTabButton.removeClass('active');
                element.addClass('active');
                loader.classList.add('active');
            },
            success: function (response) {
                element.addClass('active');
                loader.classList.remove('active');
                const html = JSON.parse(response);
                socialFilesWrapper.html(html.data);
            },
        });
    }
}

changeTabButton.on('click', (e) => {
    loadTabContent($(e.currentTarget))
})